exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:768px){.w-50-mobile[data-v-18d7156f]{width:50%!important}.w-100-mobile[data-v-18d7156f]{width:100%!important}}.label[data-v-18d7156f]{font-weight:400;font-size:.9rem}input[data-v-18d7156f]:invalid{background-color:#ffbebe}figure img[data-v-18d7156f],img[data-v-18d7156f]{max-height:none}", ""]);

// exports
